import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-697a2760"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "billing-history",
  "aria-labelledby": "billing-history-title"
}
const _hoisted_2 = { class: "billing-history__heading" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "billing-eyebrow" }, "Histórico", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { id: "billing-history-title" }, "Pagamentos anteriores", -1))
const _hoisted_5 = {
  key: 0,
  class: "billing-history__skeletons",
  "aria-label": "Carregando histórico de pagamentos"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "billing-feedback billing-feedback--error",
  role: "alert"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-warning-circle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_12 = { class: "billing-history__table-wrap" }
const _hoisted_13 = { class: "billing-history__table" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Referência"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Pagamento"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-end"
    }, "Valor"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-end"
    }, "Link")
  ])
], -1))
const _hoisted_15 = { class: "billing-history__reference" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-calendar-check",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_17 = { class: "text-end" }
const _hoisted_18 = { class: "text-end" }
const _hoisted_19 = ["href"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-arrow-square-out",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 1,
  class: "billing-history__muted"
}
const _hoisted_23 = { class: "billing-history__cards" }
const _hoisted_24 = { class: "billing-history-card__top" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "billing-history__reference-icon" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-calendar-check",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_26 = { class: "billing-history-card__bottom" }
const _hoisted_27 = ["href"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-arrow-right",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "billing-pagination" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-caret-left",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_33 = ["disabled"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-caret-right",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_35 = {
  key: 3,
  class: "billing-empty"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "ph ph-receipt",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Nenhum pagamento encontrado", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Quando houver faturas, elas aparecerão aqui para consulta rápida.", -1))
const _hoisted_39 = [
  _hoisted_36,
  _hoisted_37,
  _hoisted_38
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("p", null, _toDisplayString(_ctx.paginationSummary), 1)
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (item) => {
            return _createElementVNode("div", {
              key: item,
              class: "billing-history__skeleton"
            }, _hoisted_9)
          }), 64))
        ]))
      : (_ctx.getErrorPaymentHistory)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", null, [
              _hoisted_11,
              _createElementVNode("span", null, _toDisplayString(_ctx.getErrorPaymentHistory), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadPage(_ctx.currentPage)))
            }, "Tentar novamente")
          ]))
        : (_ctx.hasHistory)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("table", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getInvoiceHistory, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: _ctx.historyKey(item)
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_15, [
                            _hoisted_16,
                            _createElementVNode("strong", null, _toDisplayString(_ctx.referenceLabel(item)), 1)
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["billing-status", _ctx.statusClass(item.status)])
                          }, _toDisplayString(_ctx.statusLabel(item.status)), 3)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(item.date_payment_formatted || 'Não pago'), 1),
                        _createElementVNode("td", _hoisted_17, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.money(item.value_formatted || item.value)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_18, [
                          (item.payment_url && item.status !== 'paid')
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: item.payment_url,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                class: "billing-link-button",
                                title: "Abrir link de pagamento",
                                "aria-label": "Abrir link de pagamento em uma nova aba"
                              }, _hoisted_21, 8, _hoisted_19))
                            : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(item.status === 'paid' ? 'Pagamento confirmado' : 'Indisponível'), 1))
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getInvoiceHistory, (item) => {
                  return (_openBlock(), _createElementBlock("article", {
                    key: `mobile-${_ctx.historyKey(item)}`,
                    class: "billing-history-card"
                  }, [
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("div", null, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.referenceLabel(item)), 1),
                        _createElementVNode("span", null, _toDisplayString(item.date_payment_formatted || 'Não pago'), 1)
                      ]),
                      _createElementVNode("span", {
                        class: _normalizeClass(["billing-status", _ctx.statusClass(item.status)])
                      }, _toDisplayString(_ctx.statusLabel(item.status)), 3)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.money(item.value_formatted || item.value)), 1),
                      (item.payment_url && item.status !== 'paid')
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: item.payment_url,
                            target: "_blank",
                            rel: "noopener noreferrer"
                          }, [
                            _createTextVNode(" Abrir fatura "),
                            _hoisted_28
                          ], 8, _hoisted_27))
                        : (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(item.status === 'paid' ? 'Pagamento confirmado' : 'Link indisponível'), 1))
                    ])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("span", null, _toDisplayString(_ctx.paginationSummary), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    type: "button",
                    disabled: _ctx.currentPage <= 1 || _ctx.loading,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToPage(_ctx.currentPage - 1)))
                  }, [
                    _hoisted_32,
                    _createTextVNode(" Anterior ")
                  ], 8, _hoisted_31),
                  _createElementVNode("button", {
                    type: "button",
                    disabled: _ctx.currentPage >= _ctx.lastPage || _ctx.loading,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToPage(_ctx.currentPage + 1)))
                  }, [
                    _createTextVNode(" Próxima "),
                    _hoisted_34
                  ], 8, _hoisted_33)
                ])
              ])
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_39))
  ]))
}